<msi-modal>
    <msi-modal-header>
        <h5 *ngIf="!logoutRequestSuccess">User is logged at different position</h5>
        <h5 *ngIf="logoutRequestSuccess">Logging out the previous session</h5>
    </msi-modal-header>
    <msi-modal-content>
        <div *ngIf='!logoutRequestSuccess'>
            You're attempting to sign in with a new session while another (remote) session is currently active.
            <br />
            <div class="caution-info">Caution: Proceeding will log out the other session.</div>
            <div class="position-info">
                Position number: {{ positionNumber }}. Position alias: {{ positionName }}
            </div>

        </div>

        <div *ngIf='logoutRequestFailed' class="fail-message">
            <div class='error'>Remote session logout failed. Please try again.</div>
        </div>
        <div *ngIf='logoutRequestSuccess' class='content-wrapper'>
            Please wait a moment while the page refreshes and you are signed in with a new session
        </div>

    </msi-modal-content>
    <msi-modal-actions align="end">
        <button *ngIf='!logoutRequestSuccess' [disabled]="logoutRequestInProgress" id="logoutCurrentSession" class="msi-btn msi-btn-action"  (click)="logoutCurrentSession()">Cancel and exit</button>
        <button *ngIf='!logoutRequestSuccess' id="logoutRequest" class="msi-btn remote-logout-btn" [disabled]="logoutRequestInProgress" (click)="sendLogoutRequest()">
            <div *ngIf='!logoutRequestInProgress'>Proceed and sign in</div>
            <div *ngIf='logoutRequestInProgress' class="msi-spinner msi-spinner-indeterminate msi-spinner-medium">
                <svg class="msi-spinner-inner" height="24" width="24" aria-label="Spinner loading content">
                    <circle fill="transparent" class="circle" stroke-width="3" r="8" cx="12" cy="12"
                            stroke-dasharray="113.09733552923255"></circle>
                    <circle fill="transparent" class="progress" stroke-width="3" r="8" cx="12" cy="12"
                            stroke-dasharray="113.09733552923255" stroke-dashoffset="84.82300164692441"></circle>
                </svg>
            </div>
        </button>
    </msi-modal-actions>
</msi-modal>

